module.exports = __webpack_public_path__ + "img/chevron-right-double.4813dbf6.svg";